function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f7534e2c-e2a4-4533-b2f3-dbfd00c98afd{fill:none;stroke:#f65e5c;stroke-width:12px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "acac3c5f-11cb-44cc-8313-7d25ebdfd73f",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "ba26bf79-ad95-4760-bf92-c58837604ef5",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "a399c240-5716-410b-be75-5ea44c050a68",
  "data-name": "Path 81",
  className: "f7534e2c-e2a4-4533-b2f3-dbfd00c98afd",
  d: "M209.2,6.05l-63,.2s-115.7,115.6-119,119.8c-16,20-21.2,39-21.2,56.9a88,88,0,1,0,109.8-85.3Z"
})));

var SvgLogoIcon3 = function SvgLogoIcon3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 223.93 276.85",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (3).ac5408f3.svg";
export { ForwardRef as ReactComponent };